import { useRef } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Plus, Trash2, Upload, Package } from "lucide-react";
import { toast } from "sonner";

function VariantRow({ v, idx, onChange, onRemove }) {
  const fileRef = useRef();
  const onFile = (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    if (f.size > 2 * 1024 * 1024) return toast.error("Ukuran maks 2MB");
    const reader = new FileReader();
    reader.onload = () => onChange({ ...v, image_url: reader.result });
    reader.readAsDataURL(f);
  };
  return (
    <div className="flex gap-2 items-start p-2 border border-neutral-200 rounded-md bg-neutral-50/50" data-testid={`variant-row-${idx}`}>
      <button type="button" onClick={() => fileRef.current?.click()} className="w-14 h-14 shrink-0 rounded border border-neutral-200 bg-white overflow-hidden flex items-center justify-center" title="Ganti foto varian" data-testid={`variant-img-btn-${idx}`}>
        {v.image_url ? <img src={v.image_url} alt={v.name} className="w-full h-full object-cover" /> : <Upload className="w-4 h-4 text-neutral-400" />}
      </button>
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`variant-img-input-${idx}`} />
      <div className="flex-1 grid grid-cols-3 gap-2">
        <div className="col-span-3 sm:col-span-1"><Input data-testid={`variant-name-${idx}`} placeholder="Nama (mis. 40 / Merah)" value={v.name} onChange={e => onChange({ ...v, name: e.target.value })} required className="h-9" /></div>
        <div><Input data-testid={`variant-stock-${idx}`} type="number" min="0" placeholder="Stok" value={v.stock} onChange={e => onChange({ ...v, stock: e.target.value })} className="h-9" /></div>
        <div><Input data-testid={`variant-price-${idx}`} type="number" min="0" placeholder="Harga (opsional)" value={v.daily_price ?? ""} onChange={e => onChange({ ...v, daily_price: e.target.value })} className="h-9" /></div>
      </div>
      <Button type="button" size="sm" variant="ghost" className="h-9 w-9 p-0 text-red-600" onClick={onRemove} data-testid={`variant-del-${idx}`}><Trash2 className="w-4 h-4" /></Button>
    </div>
  );
}

export function VariantEditor({ variants, onChange }) {
  const update = (i, nv) => onChange(variants.map((v, j) => (j === i ? nv : v)));
  const remove = (i) => onChange(variants.filter((_, j) => j !== i));
  const add = () => onChange([...variants, { id: "", name: "", stock: 0, image_url: "", daily_price: "" }]);
  return (
    <div className="border-t border-neutral-200 pt-3">
      <div className="flex items-center justify-between">
        <div>
          <Label className="flex items-center gap-1"><Package className="w-3 h-3" /> Varian (Ukuran / Warna)</Label>
          <p className="text-[10px] text-neutral-500 mt-0.5">Jika ada varian, stok dihitung per varian. Harga kosong = ikut harga produk.</p>
        </div>
        <Button type="button" size="sm" variant="outline" onClick={add} data-testid="add-variant-btn"><Plus className="w-3 h-3 mr-1" /> Tambah Varian</Button>
      </div>
      <div className="space-y-2 mt-2">
        {variants.map((v, i) => <VariantRow key={i} v={v} idx={i} onChange={nv => update(i, nv)} onRemove={() => remove(i)} />)}
        {variants.length === 0 && <div className="text-xs text-neutral-400 text-center py-2">Tanpa varian — stok utama dipakai</div>}
      </div>
    </div>
  );
}
